import React, { createContext, useContext, useState } from 'react';

const GameContext = createContext();

export const useGame = () => {
  const context = useContext(GameContext);
  if (!context) {
    throw new Error('useGame must be used within GameProvider');
  }
  return context;
};

export const GameProvider = ({ children }) => {
  const [gameState, setGameState] = useState('home');
  const [players, setPlayers] = useState([]);
  const [totalPlayers, setTotalPlayers] = useState(6);
  const [civilianCount, setCivilianCount] = useState(5);
  const [imposterCount, setImposterCount] = useState(1);
  const [mrWhiteCount, setMrWhiteCount] = useState(0);
  const [wordPair, setWordPair] = useState(null);
  const [currentPlayerIndex, setCurrentPlayerIndex] = useState(0);
  const [revealedPlayers, setRevealedPlayers] = useState([]);
  const [votingPlayerIndex, setVotingPlayerIndex] = useState(0);
  const [eliminatedPlayer, setEliminatedPlayer] = useState(null);
  const [winner, setWinner] = useState(null);
  const [audioEnabled, setAudioEnabled] = useState(true);
  const [voiceType, setVoiceType] = useState('default');
  const [round, setRound] = useState(1);
  const [showRoles, setShowRoles] = useState(false);

  const resetGame = () => {
    setGameState('home');
    setPlayers([]);
    setTotalPlayers(6);
    setCivilianCount(5);
    setImposterCount(1);
    setMrWhiteCount(0);
    setWordPair(null);
    setCurrentPlayerIndex(0);
    setRevealedPlayers([]);
    setVotingPlayerIndex(0);
    setEliminatedPlayer(null);
    setWinner(null);
    setRound(1);
  };

  const resetForNewRound = () => {
    const resetPlayers = players.map(p => ({ ...p, isEliminated: false, vote: null }));
    setPlayers(resetPlayers);
    setWordPair(null);
    setCurrentPlayerIndex(0);
    setRevealedPlayers([]);
    setVotingPlayerIndex(0);
    setEliminatedPlayer(null);
    setWinner(null);
    setRound(1);
    setGameState('nameEntry');
  };

  const value = {
    gameState,
    setGameState,
    players,
    setPlayers,
    totalPlayers,
    setTotalPlayers,
    civilianCount,
    setCivilianCount,
    imposterCount,
    setImposterCount,
    mrWhiteCount,
    setMrWhiteCount,
    wordPair,
    setWordPair,
    currentPlayerIndex,
    setCurrentPlayerIndex,
    revealedPlayers,
    setRevealedPlayers,
    votingPlayerIndex,
    setVotingPlayerIndex,
    eliminatedPlayer,
    setEliminatedPlayer,
    winner,
    setWinner,
    audioEnabled,
    setAudioEnabled,
    voiceType,
    setVoiceType,
    round,
    setRound,
    showRoles,
    setShowRoles,
    resetGame,
    resetForNewRound,
  };

  return <GameContext.Provider value={value}>{children}</GameContext.Provider>;
};
